module.exports = __webpack_public_path__ + "img/specialist-absences.2c57fb64.svg";